<template>
  <svg v-bind="svgAttributes" v-html="svgContent"></svg>
</template>

<script>
export default {
  props: {
    icon: String,
  },

  data() {
    return {
      svgString: null,
    };
  },

  created() {
    this.getSvg();
  },

  watch: {
    icon: function() {
      this.getSvg();
    },
  },

  computed: {
    iconPath: {
      cache: false,

      get() {
        return this.icon.replace(new RegExp('.'.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'), 'g'), '/') + '.svg';
      },
    },

    svgAttributes() {
      if (!this.svgString) return {};

      const svgAttributes = {};

      const regex = /<svg([^>]*)>/i;
      const match = this.svgString.match(regex);

      if (match) {
        const svgAttributesString = match[1];

        // Expresión regular para extraer los atributos del elemento <svg>
        const attributeRegex = /([\w-]+)\s*=\s*"([^"]*)"/g;
        let attributeMatch;

        // Iterar sobre los atributos encontrados y agregarlos al objeto svgAttributes
        while ((attributeMatch = attributeRegex.exec(svgAttributesString)) !== null) {
          const attributeName = attributeMatch[1];
          const attributeValue = attributeMatch[2];
          svgAttributes[attributeName] = attributeValue;
        }
      }

      return svgAttributes;
    },

    svgContent() {
      return this.svgString ? this.svgString.replace(/^<svg[^>]*>|<\/svg>$/g, '') : null;
    },
  },
  methods: {
    getSvg() {
      let svg = require(`../../icons/${this.iconPath}`);
      this.svgString = svg.default;
    },
  },
};
</script>
